import React, { useState } from 'react';
import { Toaster } from 'sonner';
import { useSeo } from '../hooks/useSeo';
import { QrControls, QrPrintSign } from '../components/openhouse/QrParts';

const signInUrlFor = (property) =>
  `${window.location.origin}/open-house${property.trim() ? `?property=${encodeURIComponent(property.trim())}` : ''}`;

export default function OpenHouseQRPage() {
  useSeo({ title: 'Open House QR Generator | Jess Sells East Coast', description: 'Generate a printable open house sign-in QR code.', path: '/open-house/qr', jsonLd: null });
  const [property, setProperty] = useState('');
  const signInUrl = signInUrlFor(property);

  return (
    <div className="min-h-screen bg-sand-100 py-10 px-4" data-testid="open-house-qr-page">
      <div className="max-w-3xl mx-auto space-y-8">
        <QrControls property={property} setProperty={setProperty} signInUrl={signInUrl} />
        <QrPrintSign property={property} signInUrl={signInUrl} />
      </div>
      <Toaster position="top-center" richColors />
    </div>
  );
}
